import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './PrivateNavbar.module.css';
import { useAuthStore } from '../store/useAuthStore';

function PrivateNavbar() {
    const [isOpen, setIsOpen] = useState(false);
    const currentUser = useAuthStore(state => state.currentUser);

    const getInitials = (name: string) => {
        if (!name) return 'U';
        const nameParts = name.trim().split(' ');
        if (nameParts.length >= 2) {
            return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
        }
        return nameParts[0].substring(0, 2).toUpperCase();
    };

    return (
        <nav className={styles.privateNavbar}>
            
            {/* LEFT SECTION: Just the Logo now */}
            <div className={styles.leftSection}>
                <NavLink to="/home" className={styles.logo}>
                    <img src="/images/oya-coincierge.png" alt="Oya Logo" className={styles.logoIcon} />
                </NavLink>
            </div>

            {/* CENTER SECTION: Search Bar */}
            <div className={styles.searchContainer}>
                <img src="/images/search.svg" alt="Search" className={styles.searchIcon} />
                <input type="text" placeholder="Search Concierge Services..." />
            </div>

            {/* HAMBURGER (Mobile Only) */}
            <button
                className={`${styles.hamburger} ${isOpen ? styles.active : ""}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span></span>
            </button>

            {/* RIGHT SECTION: Links, Icons, & Profile */}
            <div className={`${styles.rightSection} ${isOpen ? styles.showMenu : ""}`}>
                
                <ul className={styles.navLinks}>
                    <li><NavLink to="/browse" className={({ isActive }) => isActive ? styles.active : ''}>Browse</NavLink></li>
                    <li><NavLink to="/requests" className={({ isActive }) => isActive ? styles.active : ''}>My Requests</NavLink></li>
                </ul>

                <div className={styles.iconGroup}>
                    <button className={styles.iconBtn}><img src="/images/mail1.svg" alt="Messages" /></button>
                    <button className={styles.iconBtn}><img src="/images/bell.svg" alt="Notifications" /></button>
                    <button className={styles.iconBtn}><img src="/images/bookmark.svg" alt="Bookmarks" /></button>
                </div>

                <div className={styles.profileDropdown}>
                    <div className={styles.avatar}>
                        {getInitials(currentUser?.fullName || currentUser?.businessName || 'User')}
                    </div>
                    <img src="/images/chevron-down.svg" alt="Menu" className={styles.chevron} />
                </div>

            </div>
        </nav>
    );
}

export default PrivateNavbar;